import React from "react";

interface IconCheckProps {
  width?: string;
  height?: string;
  fill?: string;
  strokeWidth?: string;
}

const IconCalendar: React.FC<IconCheckProps> = ({
  width = "20px",
  height = "20px",
  fill = "#f7f5f5",
  strokeWidth,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth || "2"}
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-list"
  >
    <path d="M8 2v4" />
    <path d="M16 2v4" />
    <rect width="18" height="18" x="3" y="4" rx="2" />
    <path d="M3 10h18" />
    <path d="M8 14h.01" />
    <path d="M12 14h.01" />
    <path d="M16 14h.01" />
    <path d="M8 18h.01" />
    <path d="M12 18h.01" />
    <path d="M16 18h.01" />
  </svg>
);
export default IconCalendar;
